// React Dependencies
import React, { useState } from 'react';

// External Dependencies
import PropTypes from 'prop-types';
import { Button, Dialog, DialogActions, DialogContent, FormControlLabel, Radio, RadioGroup, Typography, makeStyles } from '@material-ui/core';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';

// Internal Dependencies
import VouchersAndCouponsTable from './table';
import OverLoading from '../../global/OverLoading';
import { GiftType, Url } from '../../../common/constants';
import apiService from '../../../services.js/apiService';

const useStyles = makeStyles({
  text: {
    fontSize: '1.231rem', // 16px
  },
});

const VouchersAndCoupons = (props) => {
  const classes =  useStyles();
  const history = useHistory();
  const pageId = props.match.params.id;

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [giftType, setGiftType] = useState(GiftType.Coupon); // by default 'Coupon' gift type selected

  const openModal = () => setIsModalOpen(true);

  const closeModal = () => setIsModalOpen(false);

  const addNewGiftHandler = async () => {
    try {
      setLoading(true);
      setIsModalOpen(false);

      const payload = {
        pageId,
        type: giftType,
      };

      const gift = await apiService.createGift(payload.pageId, payload);
      history.push(Url.Gift.replace(':pageId', pageId).replace(':giftId', gift.id));
    } catch (err) {
      console.log('Error in createGiftHandler: ', err.message);
      toast.error(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      { loading && <OverLoading /> }
      <div className="py-3">
        <Button onClick={openModal} variant="contained" color="primary" size="medium">Add Gift</Button>
      </div>

      <div>
        <VouchersAndCouponsTable pageId={pageId} />
      </div>

      <Dialog open={isModalOpen} fullWidth maxWidth="xs" onClose={closeModal}>
        <DialogContent className="mt-3">
          <Typography variant="body1" className={`font-weight-bold mb-3 ${classes.text}`}>Add Coupon / Voucher</Typography>

          <Typography variant="body1" className={classes.text}>Select Type</Typography>
          <RadioGroup row name="giftType" value={giftType} onChange={(e) => setGiftType(e.target.value)}>
            <FormControlLabel
              value={GiftType.Coupon}
              control={<Radio color="primary" />}
              label={<Typography className={classes.text}>{GiftType.Coupon}</Typography>}
            />
            <FormControlLabel
              value={GiftType.Voucher}
              control={<Radio color="primary" />}
              label={<Typography className={classes.text}>{GiftType.Voucher}</Typography>}
            />
          </RadioGroup>
        </DialogContent>

        <DialogActions>
          <Button onClick={() => closeModal()} color="primary" variant="text">Cancel</Button>
          <Button onClick={() => addNewGiftHandler()} color="primary" variant="contained">Next</Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

VouchersAndCoupons.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string,
    }),
  }).isRequired,
};

export default VouchersAndCoupons;
